import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
// Token files first: CSS @import must precede Tailwind's directives.
import './theme.css'
import './brand.css'
import './index.css'
import { AuthGate } from './auth/AuthGate'
import App from './App'
import DriverBoardApp from './driver/DriverBoardApp'

// /board is the drivers' own page and lives outside the cockpit entirely: its
// own Google sign-in with no fleetly.co.za hint, none of the cockpit's
// providers, and only the driver/ API routes behind it. Deciding this before
// the router means a driver never mounts a single cockpit component.
const isDriverBoard = window.location.pathname === '/board' || window.location.pathname.startsWith('/board/')

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {isDriverBoard ? (
      <DriverBoardApp />
    ) : (
      <BrowserRouter>
        <AuthGate>
          <App />
        </AuthGate>
      </BrowserRouter>
    )}
  </StrictMode>,
)
